<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active" aria-current="page">Proyectos en Proceso</li>
            </ol>
        </nav>

        <div class="container-fluid">
            <div class="row">
                <!-- TITLE -->
                <div class="col-md-12 mb-4">
                    <vx-card>
                        <h1 class="bold big-title m-0">Proyectos en <span>proceso</span>.</h1>
                    </vx-card>
                </div>

                <!-- FILTER -->

                <div class="col-md-12 mb-4">
                    <vx-card title="Filtros">
                        <div class="row mb-0">
                            <!-- filter type -->
                            <div class="col-md-4">
                                <p class="bold">Selecciona el tipo de filtro a aplicar</p>
                                <vs-checkbox color="warning" class="mb-1" id="0" v-model="filterType[0]" value="0"> Estatus de proyecto </vs-checkbox>
                                <vs-checkbox color="warning" class="mb-1" id="1" v-model="filterType[1]" value="1"> Estatus de contratos </vs-checkbox>
                                <vs-checkbox color="warning" class="mb-1" id="2" v-model="filterType[2]" value="2"> Estatus de anexos </vs-checkbox>
                                <vs-checkbox color="warning" class="mb-1" id="3" v-model="filterType[3]" value="3"> Estatus de evidencias </vs-checkbox>
                                <vs-checkbox color="warning" class="mb-1" id="4" v-model="filterType[4]" value="4"> Estatus Encuesta de satisfacción </vs-checkbox>
                                <vs-checkbox color="warning" class="mb-1" id="5" v-model="filterType[5]" value="5"> Tiempo transcurrido TT </vs-checkbox>
                            </div>
                             <!-- filter options  -->
                            <div class="col-md-8">
                                <p class="bold">Selecciona la opción para filtrar</p>
                                <div class="row mb-0">
                                    <!-- Estatus de proyecto -->
                                    <div v-if="filterType[0]" class="col-md-3 col-sm-12 mb-4">
                                        <label for="projectStatus">Estatus de proyecto</label>
                                        <vs-select
                                            v-model.number="filter[0]"
                                            class="w-full select-large"
                                            v-validate="'required'"
                                            name="projectStatus"
                                            placeholder="Seleccione una opción">
                                        <vs-select-item
                                            :key="index"
                                            :value="item.value"
                                            :text="item.text"
                                            v-for="(item,index) in projectStatus"
                                            class=""/>
                                        </vs-select>
                                    </div>
                                    <!-- Estatus de contrato -->
                                    <div v-if="filterType[1]" class="col-md-3 col-sm-12 mb-4">
                                        <label for="contractsStatus">Estatus de contratos</label>
                                        <vs-select
                                            v-model.number="filter[1]"
                                            class="w-full select-large"
                                            v-validate="'required'"
                                            name="contractsStatus"
                                            placeholder="Seleccione una opción">
                                        <vs-select-item
                                            :key="index"
                                            :value="item.value"
                                            :text="item.text"
                                            v-for="(item,index) in contractsStatus"
                                            class=""/>
                                        </vs-select>
                                    </div>
                                    <!-- Estatus de anexo -->
                                    <div v-if="filterType[2]" class="col-md-3 col-sm-12 mb-4"> 
                                        <label for="annexedsStatus">Estatus de anexos</label>
                                        <vs-select
                                            v-model.number="filter[2]"
                                            class="w-full select-large"
                                            v-validate="'required'"
                                            name="annexedsStatus"
                                            placeholder="Seleccione una opción">
                                        <vs-select-item
                                            :key="index"
                                            :value="item.value"
                                            :text="item.text"
                                            v-for="(item,index) in contractsStatus"
                                            class=""/>
                                        </vs-select>
                                    </div>
                                    <!-- Estatus de evidencia -->
                                    <div v-if="filterType[3]" class="col-md-3 col-sm-12 mb-4">
                                        <label for="evidenceStatus">Estatus de evidencia</label>
                                        <vs-select
                                            v-model.number="filter[3]"
                                            class="w-full select-large"
                                            v-validate="'required'"
                                            name="evidenceStatus"
                                            placeholder="Seleccione una opción">
                                        <vs-select-item
                                            :key="index"
                                            :value="item.value"
                                            :text="item.text"
                                            v-for="(item,index) in evidenceStatus"
                                            class=""/>
                                        </vs-select>
                                    </div>
                                    <!-- Estatus de encuesta de satisfaccón -->
                                    <div v-if="filterType[4]" class="col-md-3 col-sm-12 mb-4">
                                        <label for="surveyStatus">Estatus de encuesta de satisfacción</label>
                                        <vs-select
                                            v-model.number="filter[4]"
                                            class="w-full select-large"
                                            v-validate="'required'"
                                            name="surveyStatus"
                                            placeholder="Seleccione una opción">
                                        <vs-select-item
                                            :key="index"
                                            :value="item.value"
                                            :text="item.text"
                                            v-for="(item,index) in surveyStatus"
                                            class=""/>
                                        </vs-select>
                                    </div>
                                    <!-- Estatus de encuesta de satisfaccón -->
                                    <div v-if="filterType[5]" class="col-md-3 col-sm-12 mb-4">
                                        <label for="TTOptions">Tiempo transcurrido TT</label>
                                        <vs-select
                                            v-model.number="filter[5]"
                                            class="w-full select-large"
                                            v-validate="'required'"
                                            name="TTOptions"
                                            placeholder="Seleccione una opción">
                                        <vs-select-item
                                            :key="index"
                                            :value="item.value"
                                            :text="item.text"
                                            v-for="(item,index) in TTOptions"
                                            class=""/>
                                        </vs-select>
                                    </div>
                                    <!-- buttons -->
                                    <div class="col-md-6 col-sm-12 mt-4">
                                        <div class="flex flex-wrap text-right justify-end">
                                            <vs-button v-if="showFilterButton" color="warning" type="filled" icon="search" @click="executeFilter()">Filtrar</vs-button>
                                            <vs-button class="ml-2" color="success" type="filled" icon="refresh" @click="getProjectsList()" >Recargar</vs-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vx-card>
                </div>

                <!-- TABLE -->
                <div class="col-md-12 mb-4">
                    <vx-card>
                        <vs-table stripe max-items="25" :data="projectsFiltered" search noDataText="No hay datos disponibles">
                            <div slot="header">
                                <h4>Lista de proyectos</h4>
                                <small>
                                    EO: Ejecutivo de originación | AR: Analista de riesgo crediticio
                                </small>
                                <br>
                                <span>Mostrando {{ projectsMetadata.from }} a {{ projectsMetadata.to }} de {{ projectsMetadata.total }} registros</span>
                            </div>
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].PID">
                                        <router-link :to="`/project/${tr.pid}`" target='_blank'>
                                            {{tr.pid}}
                                        </router-link>
                                    </vs-td>
                                    <vs-td>
                                        <strong>{{tr.client.name}}</strong>
                                        <br> {{tr.client.email}}
                                        <br> {{phoneFormat(tr.client.phone)}}
                                        <br> {{tr.client.alias}}
                                        <div class="clickable" v-if="tr.potential_applicant != null" @click.stop="currentLead = tr.potential_applicant, popupActivoProgram = true">
                                            <vs-chip color="#f44336">
                                                <strong>{{ tr.potential_applicant.program_info.name }}</strong>
                                            </vs-chip>
                                        </div>
                                        <p class="bold"><u>{{ tr.financial_product_name }}</u></p>
                                    </vs-td>
                                    <vs-td>
                                        EO: {{ tr.origination_responsible || '--' }} <br>
                                        AR: {{ tr.credit_risk_responsible || '--' }}
                                    </vs-td>
                                    <vs-td v-if="tr.supplier != null">
                                        <strong>{{ tr.supplier.id }} | {{tr.tradename}}</strong><br>
                                        <div class="clickable" @click="showSupplierInformation(tr.supplier.id)">
                                            <vs-chip transparent color="warning">
                                                <span class="bold text-xs">Ver informacion del proveedor</span>
                                            </vs-chip>
                                        </div> <br>
                                        <supplier-agent-information :projectId="tr.pid"></supplier-agent-information>
                                    </vs-td>
                                    <vs-td v-else>
                                        Sin proveedor
                                    </vs-td>
                                    <vs-td>
                                        <span class="bold text-xs">{{tr.project_status}}</span>
                                    </vs-td>
                                    <vs-td>
                                        <span class="bold">{{tr.project_tt}}</span>
                                    </vs-td>
                                    <vs-td>
                                        <div class="flex text-center cursor-pointer" @click="setCurrentProjectInfo(tr.pid, 'contracts')" >
                                            <vs-chip transparent :color="setContractsTriage(tr.contracts, tr.contractsList).color">
                                                <span class="bold text-xs">{{setContractsTriage(tr.contracts).text}}</span>
                                            </vs-chip>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="flex text-center cursor-pointer"  @click="setCurrentProjectInfo(tr.pid, 'invoices')">
                                            <vs-chip transparent :color="setInvoiceTriage(tr.invoices)">
                                                <span class="bold text-xs">{{setInvoicesStatus(tr.invoices)}}</span>
                                            </vs-chip>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="flex text-center cursor-pointer" @click="setCurrentProjectInfo(tr.pid, 'evidences')" >
                                            <vs-chip transparent :color="setTriage(tr.serial_numbers)">
                                                <span class="bold text-xs">{{tr.serial_numbers}}</span>
                                            </vs-chip>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="flex text-center cursor-pointer" @click="setCurrentProjectInfo(tr.pid, 'evidences')">
                                            <vs-chip transparent :color="setTriage(tr.evidence_status)">
                                                <span class="bold text-xs">{{tr.evidence_status}}</span>
                                            </vs-chip>
                                        </div>
                                    </vs-td>
                                     <vs-td>
                                        <div @click="handleAction(tr)" class="flex text-center cursor-pointer">
                                            <vs-chip transparent :color="setTriage(tr.survey_status)">
                                                <span class="bold text-xs">{{tr.survey_status}}</span>
                                            </vs-chip>
                                            <!-- <vs-button v-if="tr.survey_status === 'Sin Generar' && tr.status >= 7" @click="sendSurveyEmails(tr.pid)" size="small" color="warning" type="line">Enviar encuesta</vs-button>
                                            <vs-button v-else-if="tr.survey_status === 'Sin contestar'" @click="sendSurveyEmails(tr.pid)" size="small" color="warning" type="line">Re-Enviar encuesta</vs-button>
                                            <vs-button v-else-if="tr.survey_status === 'Contestada'" @click="getSurvey(tr)" size="small" color="warning" type="line">Ver encuesta</vs-button> -->
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <div class="flex text-center cursor-pointer" @click="setCurrentProjectInfo(tr.pid, 'contracts')">
                                            <vs-chip transparent :color="setContractsTriage(tr.annexed).color">
                                                <span class="bold text-xs">{{setContractsTriage(tr.annexed).text}}</span>
                                            </vs-chip>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                      <div @click="supplierPaymentPopUpHandler(tr.pid)">
                                        <vs-chip transparent color="success" v-if="tr.loan_payment.total > 0">
                                          <span class="bold text-xs">Pagos {{tr.loan_payment.pending}} / {{tr.loan_payment.total}}</span>
                                        </vs-chip>
                                        <vs-chip color="dark" transparent v-else>
                                          <span class="bold text-xs">Sin Pagos</span>
                                        </vs-chip>
                                      </div>
                                    </vs-td>
                                    <vs-td>
                                        <span>{{tr.installation_date}}</span>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                        <vs-pagination
                            v-model="currentPage"
                            :total="projectsMetadata.last_page"
                            @change="getProjectsList()" />
                                                            <span>Mostrando {{ projectsMetadata.from }} a {{ projectsMetadata.to }} de {{ projectsMetadata.total }} registros</span>
                    </vx-card>
                </div>

                <vs-popup title="ESTRUCTURA DE PAGOS" :active.sync="supplierPaymentPopUp" fullscreen>
                  <vs-button
                    @click="supplierPaymentWindowHandler"
                    class="float-right"
                    color="success"
                    icon="open_in_new">
                    Ver en otra pestaña
                  </vs-button>

                  <loan-payment-view
                    v-if="pidSelected"
                    ref="loanPaymentModule"
                    :project-id="pidSelected" />
                </vs-popup>

                <!-- ESTATUS DE CONTRATOS -->
                <vs-popup title="ESTATUS DE CONTRATOS" :active.sync="contractsPopUp" fullscreen>
                    <contracts2-tab v-if="contractsPopUp" :project="project" :isFromProjects="false"/>
                </vs-popup>

                 <!-- ESTATUS DE EVIDENCIAS -->
                <vs-popup title="ESTATUS DE EVIDENCIAS" :active.sync="evidencesPopUp" fullscreen>
                    <project-evidences-revision-tab
                      v-if="evidencesPopUp"
                      :id="project.id"
                      :project-evidence-date="project.complete_evidence_date"
                      :person_type="project.client.user.person_type" />
                </vs-popup>

                 <!-- MODAL ENCUESTA -->
                <vs-popup :title="`Encuesta para PID: ${projectSelected.pid} - ${projectSelected.alias}`" :active.sync="popupActivoSurvey">
                    <template v-if="survey.length > 0">
                        <vs-table ref="table" stripe :data="survey" noDataText="No hay datos disponibles" >
                            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4"></div>
                            <template slot="thead">
                                <vs-th v-for="(col, idx) in columns_survey" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <template v-for="(tr, indextr) in data">
                                    <vs-tr v-if="tr.type == 'SP_QUESTION'" :key="indextr"  :data="tr">
                                        <vs-td>
                                            {{tr.question}} <br>
                                            <small>{{tr.indications}}</small>
                                        </vs-td>
                                        <vs-td>
                                            {{getQuestionType(tr)}}
                                        </vs-td>
                                        <vs-td>
                                            {{getYesOrNOAnswers(tr)}}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                                <template v-for="(tr, indextr) in data">
                                    <vs-tr v-if="tr.type == 'RG_QUESTION'" :key="indextr"  :data="tr">
                                        <vs-td>
                                            {{tr.question}} <br>
                                            <small>{{tr.indications}}</small>
                                        </vs-td>
                                        <vs-td>
                                            {{getQuestionType(tr)}}
                                        </vs-td>
                                        <vs-td>
                                            {{getYesOrNOAnswers(tr)}}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </template>
                        </vs-table>
                    </template>
                    <template v-else>
                        <template v-if="isSurveyGeneated">
                            <vx-card title="Encuesta de satisfacción">
                                <p class="mb-6">Parece que aún no ha sido respondida la encuesta de satisfacción de este proyecto. Puedes reenviar un recordatorio desde el botón "Renviar encuesta".</p>
                                <vs-button class="mb-4" color="warning" @click.stop="sendSurveyEmails(projectSelected.pid)">Renviar encuesta</vs-button>
                                <p class="bold orange">URL: {{surveyUrl}}</p>
                            </vx-card>
                        </template>
                        <template v-else>
                            <vx-card title="Encuesta de satisfacción">
                                <p class="mb-6">Parece que aún no ha sido respondida la encuesta de satisfacción de este proyecto. Puedes enviar un recordatorio desde el botón "Enviar encuesta".</p>
                                <vs-button color="warning" @click.stop="sendSurveyEmails(projectSelected.pid)">Enviar encuesta</vs-button>
                            </vx-card>
                        </template>
                    </template>
                </vs-popup>

                <!-- MODAL INVOICE -->
                <vs-popup title="FACTURAS DE PROYECTO" :active.sync="popupActivoInvoices" fullscreen>
                    <vx-card title="Facturas">
                        <invoices-control
                        v-if="popupActivoInvoices"
                        ref="invoices"
                        :project_id="project.id"
                        :isDisabled="true"
                    />
                    </vx-card>
                </vs-popup>

                <!-- SUPPLIER INFORMATION -->
                <vs-popup title="Información del Proveedor" :active.sync="showFormPromptSupplierInfo">
                    <supplier-details v-if="currentSupplierID !== null" ref="supplierDetails" :supplier_id="currentSupplierID"></supplier-details>
                </vs-popup>

                <!-- INFORMACIÓN DE PROGRAMA -->
                <vs-popup v-if="currentLead" class="mid-popup header-primary" title="Detalle del lead de programa" :active.sync="popupActivoProgram">
                    <vx-card>
                        <h3>Información</h3>
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <p class="bold">Cliente: </p> <span>{{ currentLead.customer_uid }} | {{ currentLead.customer_name }}</span> <br>
                                <p class="bold">Zona | Región: </p> <span> {{ getZone(currentLead) }} | {{ getRegion(currentLead) }}</span> <br>
                            </div>
                        </div>
                    </vx-card>
                </vs-popup>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";
import Contracts2Tab from '../projects/process-flow/tab-contracts2';
import ProjectEvidencesRevisionTab from '@components/projectsv2/ProjectEvidencesRevisionTab.vue';
import InvoicesControl from '@projects/InvoicesControl.vue';
import SupplierAgentInformation from "@projects/SupplierAgentInformation";
import SupplierDetails from "./process-flow/SupplierDetails.vue"
import LoanPaymentView from "@views/admin/loan-payment/loan-payment-view";

const columns = [
    { title: "PID", key: "pid", sortable: true }
    , { title: "SOLICITANTE", key: "client", sortable: true }
    , { title: "Responsables", key: "client", sortable: true }
    , { title: "PROVEEDOR", key: "supplier", sortable: true }
    , { title: "ESTATUS DE PROYECTO", key: "project_status", sortable: false }
    , { title: "TT (días)", key: "tt", sortable: false }
    , { title: "ESTATUS DE CONTRATOS", key: "contracts_status", sortable: false }
    , { title: "FACTURAS DE PROYECTO", key: "project_invoices", sortable: false }
    , { title: "NÚMEROS DE SERIE", key: "serial_numbers", sortable: false }
    , { title: "EVIDENCIAS", key: "evidencias", sortable: false }
    , { title: "ENCUESTA", key: "survey", sortable: false }
    , { title: "ESTATUS DE ANEXOS", key: "anexo_status", sortable: false }
    , { title: "PAGOS PROYECTO", key: "loan_payments", sortable: false }
    , { title: "F. PRIMER PAGO", key: "installation_date", sortable: false }
];

const contractsStatus = [
    { value: "created", text: "Creados" }
    , { value: "sent", text: "Enviados" }
    , { value: "signed", text: "Firmados" }
    , { value: "verified", text: "Verificados" }
    , { value: "not_created", text: "Sin generar" }
];

const evidenceStatus = [
    { value: "Pendientes", text: "Pendientes" }
    , { value: "Incompletas", text: "Incompletas" }
    , { value: "En revisión", text: "En revisión" }
    , { value: "Verificadas", text: "Verificadas" }
];

const surveyStatus = [
    { value: "Sin Generar", text: "Sin generar" }
    , { value: "Sin contestar", text: "Sin contestar" }
    , { value: "Contestada", text: "Contestada" }
];

const projectStatus = [
    { value: "5", text: "En fondeo" }
    , { value: "6", text: "Firma de contratos" }
    , { value: "7", text: "En instalación" }
];

const TTOptions = [
    { value: "0.10", text: "de 0 a 10 días" }
    , { value: "11.20", text: "de 11 a 20 días" }
    , { value: "21.30", text: "de 21 a 30 días" }
    , { value: "30.0", text: "Más de 30 días" }
];

const columns_survey = [
    { title: "PREGUNTA", key: "project", sortable: false}
    , { title: "TIPO", key: "applicant", sortable: false}
    , { title: "RESPUESTA", key: "supplier", sortable: false}
];

const spQuestionIds = [64,65,66];
const URL_PATH = "https://app.redgirasol.com/encuesta/?";

export default {
    name: "projects-in-process",
    mixins: [formatHelper],
    data(){
        return {
            projects: []
            , projectsFiltered: []
            , columns: columns
            , filterType: [false,false,false,false,false,false]
            , contractsStatus: contractsStatus
            , evidenceStatus: evidenceStatus
            , surveyStatus: surveyStatus
            , projectStatus: projectStatus
            , TTOptions: TTOptions
            , filter: []
            , project: {}
            , contractsPopUp: false
            , evidencesPopUp: false
            , supplierPaymentPopUp: false
            , pidSelected: null
            , columns_survey: columns_survey
            , projectSelected: {}
            , popupActivoSurvey: false
            , survey: []
            , spQuestionIds: spQuestionIds
            , popupActivoInvoices: false
            , isSurveyGeneated: false
            , surveyUrl: "--"
            , currentSupplierID: null
            , showFormPromptSupplierInfo: false
            , popupActivoProgram: false
            , currentLead: null
            , currentPage: 1
            , perPages: 20
            , projectsMetadata: { total: 0, from: 0, to: 0, last_page: 1, per_page: 20, current_page: 1 }
        }
    },
    components: {
      LoanPaymentView,
        Contracts2Tab
        , ProjectEvidencesRevisionTab
        , InvoicesControl
        , SupplierAgentInformation
        , SupplierDetails
    },
    mounted(){
        this.getProjectsList();
    },
    computed: {
        showFilterButton(){
            let i = 0;
            let arrLength = this.filterType.length;

           for (i; i < arrLength; i++) {
               if(this.filterType[i]){
                   return true;
               }
           }

           return false;
        }
    },
    methods: {
        supplierPaymentWindowHandler() {
          window.open(`/loan-payments/pid/${this.pidSelected}`)
        },
        async supplierPaymentPopUpHandler(pid) {
          this.supplierPaymentPopUp = true;
          this.pidSelected = pid;
          //await this.$refs.loanPaymentModule.changeProject(pid)
        },
        async getProjectsList(){
            this.showLoading(true);
            try {
                const res = await axios.get(`/api/v2/projects/getProjectsInProcess?page=${this.currentPage}&per_page=${this.perPages}`);
                this. filter = [];
                this.filterType = [false,false,false,false,false,false];
                this.projects = res.data;
                this.projectsFiltered = res.data.data;
                this.projectsMetadata = res.data.meta;


            } catch (error) {
               this.warn(error);
            }
            this.showLoading(false);
        },
        setTriage(status){
            let colorClass = "primary";
            if(status === "Verificadas" || status === "Contestada"|| status === "Completas"){
                colorClass = "success";
            } else if(status === "En revisión") {
                colorClass = "warning";
            } else if(status === "Incompletas" || status === "Sin contestar"){
                colorClass = "danger";
            } else if (status === "Sin Generar" || status === "Pendientes") {
                colorClass = "dark";
            }

            return colorClass;
        },
        setContractsTriage(contracts, contractsList = null){
            let res = {
                color: "primary"
                , text: "Sin Generar"
                };

            if(contracts !== null && contracts.length !== 0){
                // Sí es el grupo 1, se debe tomar en cuenta también el pagaré
                let statusContract = contracts[0].status;
                if(contracts[0].group_id == 1 && contractsList != null) {
                    let pagare = contractsList.find(x => x.type.name == "Pagaré");
                    if(pagare !== undefined){
                        if(statusContract == "signed" && pagare.status == "signed"){
                            statusContract = "signed";
                        } else if(statusContract == "verified" && pagare.status == "verified") {
                            statusContract = "verified";
                        } else if(statusContract == "generated" || pagare.status == "generated") {
                            statusContract = "generated";
                        } else if(statusContract == "canceled" || pagare.status == "canceled") {
                            statusContract = "generated";
                        } else if(statusContract == "sent" || pagare.status == "sent") {
                            statusContract = "sent";
                        }
                    }
                }
                switch(statusContract){
                    case "generated":
                        res.color = "dark";
                        res.text = "Generados";
                        break;
                    case "sent":
                        res.color = "warning";
                        res.text = "Enviados";
                        break;
                    case "signed":
                        res.color = "success";
                        res.text = "Firmados";
                        break;
                    case "canceled":
                        res.color = "danger";
                        res.text = "Cancelados";
                        break;
                    case "verified":
                        res.color = "success";
                        res.text = "Verificados";
                        break;
                }
            }

            return res;
        },
        setInvoicesStatus(invoices){
            let status = "Pendientes";
            if(invoices.length !== 0){
                let invoice = invoices[0];
                status = this.capitalizeFirstLetter(invoice.document_status);
            }

            return status;
        },
        setInvoiceTriage(invoices){
            let color = "dark";
            if(invoices.length !== 0){
                let invoice = invoices[0];
                let status = invoice.document_status;

                if(status === "rechazado"){
                    color = "danger";
                } else if(status === "verificado") {
                    color = "success";
                } else {
                    color = "warning";
                }
            }

            return color;
        },
        executeFilter(){
            let projects = this.projects;
            let i = 0 ;
            let arrLength = this.filterType.length;

            for(i; i <= arrLength; i++){
                if(this.filterType[i]){
                    switch(i){
                        case 0:
                            projects = this.filterProjects(projects, "status", this.filter[i]);
                        break;
                        case 1:
                            projects = this.filterByContracts(projects, this.filter[i], true);
                            break;
                        case 2:
                            projects = this.filterByContracts(projects, this.filter[i], false);
                            break;
                        case 3:
                            projects = this.filterProjects(projects, "evidence_status", this.filter[i]);
                        break;
                        case 4:
                            projects = this.filterProjects(projects, "survey_status", this.filter[i]);
                        break;
                        case 5:
                            projects = this.filterByTT(projects, this.filter[i]);
                        break;
                    }
                }
            }
            this.projectsFiltered = projects;
        },
        filterProjects(projects, field, filter){
            return projects.filter(x => x[field] === filter);
        },
        filterByTT(projects, filter){
            let collections;
            let ranges = filter.toString();
            if(ranges !== "30"){
                ranges += "0";
            }
            ranges = ranges.split(".");
            ranges = ranges.map(Number);

            if(ranges[0] === 30) {
                collections = projects.filter(x => x.project_tt > ranges[0]);
            } else {
                collections = projects.filter(x => (x.project_tt >= ranges[0] && x.project_tt <= ranges[1]));
            }

            return collections;
        },
        filterByContracts(projects, filter, contractsType){
            let field = contractsType ? "contracts" : "annexed"
            let collection;
            if(filter === "not_created"){
                collection = projects.filter(x => x[field].length === 0);
            } else {
                collection = projects.filter(x => x[field][0] === filter);
            }

            return collection
        },
        async getProjectInfo(project_id){
            try {
                const requiredObjects = [
                    "splits",
                    "client.user",
                    "client.user.personal",
                    "client.user.business",
                    "client.user.business.personal",
                    "agent",
                    "finance",
                    "contracts",
                    "supplier.user",
                    "supplier.user.personal",
                    "supplier.user.business",
                    "supplier.user.business.personal"
                ];

                let params = "with[]=" + requiredObjects.join("&with[]=");
                let response = await axios.get(`/api/v2/projects/${project_id}?${params}`);
                this.project = response.data;
            } catch (error) {
                this.processError(error.status);
            }
        },
        async setCurrentProjectInfo(project_id, option){
            this.project = {};
            await this.getProjectInfo(project_id);
            switch(option){
                case "contracts":  this.contractsPopUp = true;       break;
                case "evidences":  this.evidencesPopUp = true;       break;
                case "invoices":   this.popupActivoInvoices = true;  break;
                default: return null;
            }
        },
        async sendSurveyEmails(project_id){
            this.showLoading(true);
            try {
                let payload = [{ "pids" : [project_id]}];
                await this.publicApiPost(`/api/v1/applicant_satisfaction_survey/sendSurveyEmails`, payload);
                this.getProjectsList();
                this.warningNotif(
                "Encuesta de satisfacción"
                , "Se ha enviado un correo al Solicitante para el llenado de la encuesta de servicio, de la cual es necesaria su respuesta para poder realizar el pago de finiquito."
                , 15000
                );
            } catch (error) {
                this.warn(error);
                this.failedOperationNotif(null, null);
            }
            this.showLoading(false);
        },
        async getSurvey(item){
            this.showLoading(true);
            try{
                let res = await axios.get(`/api/applicant_satisfaction_survey/${item.pid}/survey/${item.client.cid}`);
                this.survey = res.data;
                if(this.survey.length != 0){
                    this.projectSelected = item;
                    this.popupActivoSurvey = true;
                } else {
                    this.warningNotif(
                    "Sin respuesta"
                    , "No se han encontrado respuestas para la encuesta de servicio para este proyecto."
                    );
                }

            }catch(err){
                this.warn(err);
                this.failedOperationNotif(null, null);
            }
            this.showLoading(false);
        },
        getYesOrNOAnswers(question)
        {
            let isQuestion = this.spQuestionIds.some(x => x == question.id);
            if(isQuestion){
                if(question.value == "5"){
                    return "Si";
                } else {
                    return "No";
                }
            } else { return question.value }
        },
        getQuestionType(question){
            if(question.type == "RG_QUESTION"){
                return "RedGirasol";
            } else if(question.type == "SP_QUESTION") {
                return "Proveedor";
            } else {
                return "--"
            }
        },
        handleAction(item){
            if(item.status >= 7){
                if(item.survey_status == "Sin Generar"){
                    this.isSurveyGeneated = false;
                } else if(item.survey_status == "Sin contestar") {
                    this.isSurveyGeneated = true;
                    this.surveyUrl = this.getURL(item);
                } else if (item.survey_status == "Contestada") {
                    this.getSurvey(item);
                }
                this.projectSelected = item;
                this.popupActivoSurvey = true;
            } else {
                 this.warningNotif(
                    "Encuesta de satisfacción"
                    , "Aún no es posible mandar la encuesta de satisfacción, es necesario que el proyecto esté en proceso de instalación."
                    , 15000
                );
            }
        },
        getURL(item){
            return `${URL_PATH}cid=${item.client.cid}&pid=${item.pid}&t=${item.client.token}`;
        },
        showSupplierInformation(sid){
            this.currentSupplierID = sid;
            this.showFormPromptSupplierInfo = true;
            this.$refs.supplierDetails.update(sid);
            this.$refs.supplierDetails.getSupplierAgents(sid);
        },
        getZone(pgmApplicant) {
        if(pgmApplicant.subregion_manager_id !== null
            && pgmApplicant.subregion_manager.region_manager_id !== null
            && pgmApplicant.subregion_manager.region_manager.zone_manager_id !== null
            && pgmApplicant.subregion_manager.region_manager.region !== null
            && pgmApplicant.subregion_manager.region_manager.region.zone !== null
            ){
                return pgmApplicant.subregion_manager.region_manager.region.zone.name;
            }
        },
        getRegion(pgmApplicant) {
            if(pgmApplicant.subregion_manager_id !== null
            && pgmApplicant.subregion_manager.region_manager_id !== null
            && pgmApplicant.subregion_manager.region_manager.region !== null
            ){
                return pgmApplicant.subregion_manager.region_manager.region.name;
            }
        },
    }
}
</script>

<style>
    .cursor-pointer {
        cursor: pointer !important;
    }
    .con-vs-dialog
    {
    z-index: 100000 !important;
    }

</style>
